<form *ngIf="form" [formGroup]="form" #ngForm>
  <div class="row">
    <div class="col-8">
      <!-- Start Date -->
      <mat-form-field color="primary">
        <mat-label>{{ "PAYMENTS.start-date" | translate }}</mat-label>
        <input matInput [matDatepicker]="startDate" formControlName="start_date"
               (dateChange)="dateChanged($event, 'end_date', false)">
        <button *ngIf="form.get('start_date') && form.get('start_date').value" mat-button matSuffix mat-icon-button
                [disabled]="form.get('start_date').disabled" (click)="clearFormControl($event, 'start_date')"
                aria-label="Clear">
          <mat-icon>close</mat-icon>
        </button>
        <mat-datepicker-toggle matSuffix [for]="startDate"></mat-datepicker-toggle>
        <mat-datepicker #startDate color="primary"></mat-datepicker>
      </mat-form-field>
      <!-- End Date -->
      <mat-form-field color="primary">
        <mat-label>{{ "PAYMENTS.end-date" | translate }}</mat-label>
        <input matInput [matDatepicker]="endDate" formControlName="end_date"
               (dateChange)="dateChanged($event, 'end_date', true)">
        <button *ngIf="form.get('end_date') && form.get('end_date').value" mat-button matSuffix mat-icon-button
                [disabled]="form.get('end_date').disabled" (click)="clearFormControl($event, 'end_date')"
                aria-label="Clear">
          <mat-icon>close</mat-icon>
        </button>
        <mat-datepicker-toggle matSuffix [for]="endDate"></mat-datepicker-toggle>
        <mat-datepicker #endDate color="primary"></mat-datepicker>
      </mat-form-field>
    </div>
    <!-- Search -->
    <div class="col-4">
      <mat-form-field class="input-full-width">
        <mat-label>{{ 'SHARED.search' | translate }}</mat-label>
        <mat-icon matPrefix>search</mat-icon>
        <input matInput formControlName="search" type="text">
        <div *ngIf="form.get('search').errors && (form.get('search').touched || ngForm.submitted)">
          <mat-error [hidden]="!form.get('name').hasError('required')">
            {{ "SHARED.field-required" | translate }}
          </mat-error>
        </div>
      </mat-form-field>
    </div>
  </div>
  <div class="row">
    <!-- Status Date Type -->
    <div class="pl-3">
      <mat-label style="padding-right: 10px; display: block">
        {{ 'CASES.list.filters.status_date_type.label' | translate }}
      </mat-label>
      <mat-radio-group formControlName="status_date_type" aria-label="Select an option">
        <mat-radio-button value="sign_up">
          {{ "CASES.list.filters.status_date_type.options.sign_up" | translate }}
        </mat-radio-button>
        <mat-radio-button value="change_date"
                          [matTooltip]="'CASES.list.filters.status_date_type.option-labels.sign_up' | translate">
          {{ "CASES.list.filters.status_date_type.options.change_date" | translate }}
        </mat-radio-button>
      </mat-radio-group>
    </div>
    <!-- Activity Status -->
    <div class="pl-5">
      <mat-label style="padding-right: 10px; display: block"
                 [matTooltip]="'CASES.list.filters.activity_status.label-tooltip' | translate">
        {{ 'CASES.list.filters.activity_status.label' | translate }}
      </mat-label>
      <mat-radio-group formControlName="activity_status" aria-label="Select an option">
        <mat-radio-button value="active">
          {{ "CASES.list.filters.activity_status.options.active" | translate }}
        </mat-radio-button>
        <mat-radio-button value="inactive">
          {{ "CASES.list.filters.activity_status.options.inactive" | translate }}
        </mat-radio-button>
        <mat-radio-button value="complete">
          {{ 'CASES.list.filters.activity_status.options.completed' | translate }}
        </mat-radio-button>
        <mat-radio-button value="all">
          {{ "CASES.list.filters.activity_status.options.all" | translate }}
        </mat-radio-button>
      </mat-radio-group>
    </div>
  </div>
  <!-- Advanced Filters -->
  <div class="filters pb-5 pt-3">
    <div class="advanced-filters">
      <mat-accordion>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div class="d-flex align-items-center justify-content-between" style="width: 100%">
                {{ "PAYMENTS.advanced-filters" | translate }}
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="row">
            <!-- Status Categories -->
            <div class="col-lg">
              <app-input *ngIf="statusCategories?.length" type="select" [formControl]="statusCategoryControl"
                         appearance="outline" [searchable]="true" [multiple]="statusMultipleSelection"
                         [label]="'CASES.single.general.status_editor.status_category' | translate"
                         [selectOptions]="statusCategories" [selectLabel]="'name'" [selectValue]="'id'"
                         class="full-width"
                         (ngModelChange)="updateSelectedStatusCategories($event)"
                         [showClear]="false" [fullWidth]="true">
              </app-input>
            </div>
            <!-- Statuses -->
            <div class="col-lg">
              <app-input *ngIf="filteredStatusCategories?.length" type="select"
                         [formControlName]="statusFormControlName"
                         appearance="outline" [searchable]="true" [multiple]="statusMultipleSelection"
                         [label]="'CASES.single.general.status_editor.status' | translate"
                         [selectOptions]="filteredStatusCategories" [optGroupProperty]="'statuses'"
                         [optGroupLabel]="'name'"
                         [selectLabel]="'name'" [selectValue]="'id'" class="full-width"
                         [showClear]="false" [fullWidth]="true">
              </app-input>
            </div>
            <!-- Creditors -->
            <div class="col-lg">
              <app-input type="select" formControlName="creditor_ids" appearance="outline"
                         fullWidth="false" [multiple]="true" [showClear]="true"
                         [label]="'CASES.single.creditors.heading' | translate" [searchable]="true"
                         [selectOptions]="creditors" [selectLabel]="'name'" [selectValue]="'id'">
              </app-input>
            </div>
            <!-- Case creditor status -->
            <div class="col-lg">
              <app-input type="select" formControlName="case_creditor_status_ids" appearance="outline"
                         [searchable]="true"
                         [label]="'CONFIG.drip-campaign.list.table-data.statusable_type.case_creditor_status' | translate"
                         [multiple]="true" [selectAll]="true" [fullWidth]="true"
                         [selectOptions]="caseCreditorStatuses"
                         [selectLabel]="authUser.locale === 'es' ? 'name_es' : 'name_en'" [selectValue]="'id'">
              </app-input>
            </div>
            <div class="col-lg">
              <app-input type="number" formControlName="amount_paid" [label]="'CASES.single.amount-paid' | translate"
                         appearance="outline"
                         [fullWidth]="true">
              </app-input>
            </div>
          </div>
          <div class="row">
            <div class="col-lg">
              <app-input type="select" id="type" appearance="outline" formControlName="creditor_types"
                         [label]="'CREDITORS.creditor-type' | translate" [showLabel]="true"
                         [showClear]="false" [selectOptions]="creditorTypes" [selectLabel]="'label'"
                         [selectValue]="'value'" [multiple]="true" [fullWidth]="true">
              </app-input>
            </div>
            <div class="col-lg">
              <ng-container *ngFor="let departmentCategory of departmentCategories">
                <ng-container *ngFor="let department of departmentCategory.departments">
                  <div class=" col-lg" *ngIf="department.active">
                    <app-input type="select" *ngIf="form" [formControlName]="department.type" appearance="outline"
                               [label]="department.name" multiple [fullWidth]="true" searchable="true"
                               [selectOptions]="department.users" [selectLabel]="'name'" [selectValue]="'id'">
                    </app-input>
                  </div>
                </ng-container>
              </ng-container>
            </div>
            <div class="col-lg">
              <app-input type="number" formControlName="settlement_funds"
                         [label]="'CASES.single.settlement_funds' | translate"
                         appearance="outline"
                         [fullWidth]="true">
              </app-input>
            </div>
            <div class="col-lg">
              <app-input type="number" formControlName="reduction_percentage"
                         [label]="'CASES.single.reduction_percentage' | translate"
                         appearance="outline"
                         [fullWidth]="true">
              </app-input>
            </div>
            <div class="col-lg">
              <app-input type="select" appearance="outline" [label]="'CONFIG.dialer.product_type' | translate"
                         formControlName="product_ids" [showClear]="false" [showLabel]="true"
                         [selectOptions]="products" [multiple]="true" [fullWidth]="true"
                         [selectLabel]="'name'" [selectValue]="'id'">
              </app-input>
            </div>
          </div>
          <div class="row">
            <div class="col-lg">
              <app-input type="number" formControlName="days_in_status" [label]="'CASES.single.days_in_status' | translate"
                         appearance="outline" [fullWidth]="true">
              </app-input>
            </div>
            <div class="col-lg">
              <app-input type="select" appearance="outline" [label]="'CASES.list.filters.can_settle.label' | translate"
                         formControlName="can_settle" [showClear]="false" [showLabel]="true"
                         [selectOptions]="canSettleOptions" [multiple]="true" [fullWidth]="true"
                         [selectLabel]="'label'" [selectValue]="'value'">
              </app-input>
            </div>
            <div class="col-lg"></div>
            <div class="col-lg"></div>
            <div class="col-lg"></div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
  <div class="row">
    <div class="col-12 d-flex justify-content-end">
      <div class="text-right">
        <button mat-raised-button color="primary" class="ml-2" (click)="this.parentFilter.emit()">
          {{ 'SHARED.apply_filters' | translate }}
        </button>
        <button mat-stroked-button color="primary" class="ml-2" (click)="this.parentClearFilters.emit()">
          {{ "SHARED.reset-filters" | translate }}
        </button>
      </div>
    </div>
  </div>
</form>
